export default __webpack_public_path__ + "static/media/successCheck.478a83de.svg";